export default __webpack_public_path__ + "static/media/DataHub.9e678a6e.svg";